const tips = {
    test: function(msg) {
        alert(msg)
    },
}
export default tips